import { type ComponentType } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useGetGapVennDetailsCountQuery,
  useGetGapVennDetailsMutation
} from '@/app/KeywordResearch/api/gapApi';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import { keywordGapColumnConfig } from '@/app/KeywordResearch/config/keywordGapColumnConfig';
import AgGridSkeleton from '@/app/common/components/skeleton/AgGridSkeleton';
import { hostApiFormatter } from '@/app/KeywordResearch/components/keyword-gap/hostApiFormatter';
import { hideDrawer } from '@/app/common/reducers/drawer';
import DrawerWrapper from '@/app/common/components/DrawerWrapper';
import type { GapHostItem } from '@/app/KeywordResearch/components/keyword-gap/hostApiFormatter';

type AgGridWrapperProps = Record<string, unknown>;
const TypedAgGridWrapper = AgGridWrapper as ComponentType<AgGridWrapperProps>;

type DrawerRootState = {
  drawer: {
    key: string;
    payload?: { set?: string };
  };
};

type VennDetailsDrawerProps = {
  submittedHosts: GapHostItem[] | null;
};

const VennDetailsDrawer = ({ submittedHosts }: VennDetailsDrawerProps) => {
  const dispatch = useDispatch();
  const { key, payload } = useSelector(
    (state: DrawerRootState) => state.drawer
  );
  const set = payload?.set;

  const { data: gridData, isFetching } = useGetGapVennDetailsCountQuery(
    {
      perPage: 50,
      page: 1,
      filters: {},
      hosts: hostApiFormatter(submittedHosts),
      set
    },
    { skip: !set || !submittedHosts }
  );
  const [getVennDetailsFunc] = useGetGapVennDetailsMutation();

  return (
    <DrawerWrapper
      show={key === 'venn'}
      onHide={() => {
        dispatch(hideDrawer());
      }}
      title={
        <div className="d-flex flex-wrap gap-3 align-items-center">
          <h6 className="m-0 fw-light">
            نمودار جزییات &nbsp;
            <span className="fw-bolder"></span>
          </h6>
        </div>
      }
    >
      <div className="mb-6">
        {!isFetching && gridData ? (
          <TypedAgGridWrapper
            height="700px"
            columns={keywordGapColumnConfig(
              gridData?.data?.columns,
              submittedHosts ?? []
            )}
            forceFilters={[]}
            total={gridData?.data?.total}
            additionalData={{
              hosts: hostApiFormatter(submittedHosts),
              set
            }}
            data={gridData?.data?.rows}
            fetchFunction={getVennDetailsFunc}
          />
        ) : (
          <AgGridSkeleton height="696px" />
        )}
      </div>
    </DrawerWrapper>
  );
};

export default VennDetailsDrawer;
